import sushiTimeVertical from '../../gfx/logo.png'
import {Spin} from 'antd'

export default function WelcomeCurtain({active}) {
  return (
    <div className={`welcome-curtain ${active ? 'active' : ''}`}>
      <img
        className="welcome-curtain-logo"
        src={sushiTimeVertical}
        alt="Sushi Time"
      />
      <br/>
      <Spin size="large"/>
    </div>
  )
}